import AppStore from "@/store/AppStore"
import { useQuery } from "react-query"
import { UserDetails } from "../../interface/UserDetails"
import { API_END_POINT, ROUTES } from "../apiClient/apiEndpoints"
import { apiClient } from "../apiClient/apiService"

const useUserDetails = () => {
  return useQuery<{ data: UserDetails }>({
    queryKey: ["userDetails"],
    queryFn: () => {
      return apiClient.get(API_END_POINT.GET[ROUTES.getUserDetails])
    },
    onSuccess: (data) => {
      AppStore.setUserDetails(data.data.data)
    },
  })
}

export default useUserDetails
